import { lazy, Suspense } from 'react';

const TechnologyLandingPage = lazy(() => import('./TechnologyLandingPage'));

export function MarketingLandingPage() {
  return (
    <Suspense fallback={<div className="dash-boot" aria-hidden="true" />}>
      <TechnologyLandingPage />
    </Suspense>
  );
}
